import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  fotaCarRequest: ['id'],
  fotaCarAddRequest: ['data'],
  fotaCarUpdateRequest: ['data'],
  fotaCarDeleteRequest: ['id'],
  fotaCarSuccess: ['data'],
  fotaCarFailure: ['error'],
});

export const FotaCarTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

export const request = state => state.merge({ fetching: true });

export const success = (state, { data }) =>
  state.merge({ fetching: false, error: null, data });

export const failure = (state, { error }) =>
  state.merge({ fetching: false, error });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FOTA_CAR_REQUEST]: request,
  [Types.FOTA_CAR_ADD_REQUEST]: request,
  [Types.FOTA_CAR_UPDATE_REQUEST]: request,
  [Types.FOTA_CAR_DELETE_REQUEST]: request,
  [Types.FOTA_CAR_SUCCESS]: success,
  [Types.FOTA_CAR_FAILURE]: failure,
});
